//#region imports
import { Component, OnInit } from '@angular/core';
import { formatDate } from '@angular/common';
import { Subscription } from 'rxjs';
import { CharacteristicService } from 'src/app/services/characteristic.service';
import { TranslateService } from '@ngx-translate/core';
import { Globals } from 'src/app/services/globals';
import { NotificationService } from 'src/app/services/notification.service';
import { CharacteristicsQuestionsSelected } from '../characteristics.model';
import { AppConstants } from 'src/app/app.constants';
import { GuaranteeService } from 'src/app/services/guarantee.service';
import { P5xService } from 'src/app/services/p5x.service';
import { SectionService } from 'src/app/services/section.service';
//#endregion

@Component({
  selector: 'app-characteristics-question5',
  templateUrl: './characteristics-question5.component.html',
  styleUrls: ['./characteristics-question5.component.css']
})
export class CharacteristicsQuestion5Component implements OnInit {
  //#region variables
  selectedCharacteristicChoice;
  characteristicsQuestionsSelected: CharacteristicsQuestionsSelected;
  characteristicsQuestionsSelectedListJSON: CharacteristicsQuestionsSelected[];
  characteristicsQuestionsSelectedList: CharacteristicsQuestionsSelected[];
  buttonText = [];
  questionGroups;
  nextQuestionId;
  flag = false;
  subscription: Subscription;
  data;
  choices = [];
  selectedText: any;
  questions: any;
  answers: any;
  selectedData: number;
  //#endregion

  //#region methods
  constructor(
    private characteristicService: CharacteristicService, private globals: Globals,
    private translate: TranslateService, private notification: NotificationService,
    private guaranteeService: GuaranteeService, private p5xService: P5xService,
    private sectionService: SectionService) {
    this.characteristicService.setShowPrevious(true);
  }

  ngOnInit() {
    this.sectionService.setCurrentPage('P1-5');
    this.characteristicService.setP1Screen(false);
    this.characteristicService.setCharacteristicChoiceSelected(false);
    const characteristicsQuestionsSelectedListStr = sessionStorage.getItem(AppConstants.LocalStorage.CharacteristicQuestionsSelectedList);
    this.characteristicsQuestionsSelectedListJSON = JSON.parse(characteristicsQuestionsSelectedListStr);
    this.characteristicService.setCurrentSection(AppConstants.SectionConstants.Section1);
    this.setData();
    this.globals.ques5Warning = false;
    this.globals.quesWarning = false;
  }

  setData() {
    const data = sessionStorage.getItem('jsonData');
    const jsonData = JSON.parse(data);
    this.questionGroups = jsonData.Sections.find(obj => obj.SectionKey === 'S1').QuestionGroup;
    this.questions = this.questionGroups.find(obj => obj.GroupKey === 'G5').Questions[0];
    this.answers = this.questionGroups.find(obj => obj.GroupKey === 'G5').Questions[0].Answers;
    const questionChoices = this.questionGroups.find(obj => obj.GroupKey === 'G5').Questions[0].QuestionChoices;
    this.selectedData = this.answers != null ? this.questions.Answers[0].ChoiceId : 0;
    for (const choice in questionChoices) {
      this.choices.push(questionChoices[choice]);
      this.buttonText[choice] = questionChoices[choice].ChoiceKey;
    }
  }

  resetAnswers() {
    const jsonData = JSON.parse(sessionStorage.getItem('jsonData'));
    this.p5xService.setP215AcceptanceCriteria(false);
    this.p5xService.setP215GridCriteriaChecked(false);
    this.p5xService.setP223IndoorPoolChecked(false);
    this.p5xService.setP225AcceptanceCriteria(false);
    this.p5xService.setP225GridCriteriaChecked(false);
    jsonData.Sections[0].QuestionGroup.find(obj => obj.GroupKey === 'G3').Questions[0].Answers = null;
    jsonData.Sections[0].QuestionGroup.find(obj => obj.GroupKey === 'G5').Questions[0].Answers = null;
    if (jsonData.Sections.find(obj => obj.SectionKey === 'S2.1')) {
      const element = jsonData.Sections.find(obj => obj.SectionKey === 'S2.1');
      const index = jsonData.Sections.indexOf(element);
      jsonData.Sections.splice(index, 1);
    } else if (jsonData.Sections.find(obj => obj.SectionKey === 'S2.2')) {
      const element = jsonData.Sections.find(obj => obj.SectionKey === 'S2.2');
      const index = jsonData.Sections.indexOf(element);
      jsonData.Sections.splice(index, 1);
    }
    sessionStorage.setItem('jsonData', JSON.stringify(jsonData));
  }

  setCharacteristicsQuestionsSelectedList(value) {
    this.characteristicService.setCharacteristicChoiceSelected(true);
    const questnId = this.questionGroups.find(obj => obj.GroupKey === 'G5').Questions[0].QuestionId;
    const questnPresent = this.characteristicsQuestionsSelectedListJSON.find(m => m.questionId === questnId);
    const index = this.characteristicsQuestionsSelectedListJSON.indexOf(questnPresent);
    let length = this.characteristicsQuestionsSelectedListJSON.length;
    if (index > -1) {
      this.characteristicsQuestionsSelectedListJSON.splice(index, length - index);
    }
    this.selectedCharacteristicChoice = value;
    length = this.characteristicsQuestionsSelectedListJSON.length;
    const previousQuestnId = this.characteristicsQuestionsSelectedListJSON[length - 1].questionId;
    this.characteristicsQuestionsSelected = {
      choiceId: value,
      GroupKey: AppConstants.GroupConstants.Group5,
      questionId: questnId,
      previousQuestionId: previousQuestnId
    };
    this.characteristicsQuestionsSelectedList = this.characteristicsQuestionsSelectedListJSON;
    this.characteristicsQuestionsSelectedList.push(this.characteristicsQuestionsSelected);
    const characteristicsQuestionsSelectedListStr = JSON.stringify(this.characteristicsQuestionsSelectedList);
    this.characteristicService.setCharacteristicsQuestionsSelectedListStr(characteristicsQuestionsSelectedListStr);
  }

  choice20Click(selectedValue) {
    this.p5xService.setSecondaryResidence(false);
    this.guaranteeService.setResidencePrinciple('true');
    this.setCharacteristicsQuestionsSelectedList(selectedValue);
    this.selectedText = this.translate.instant(selectedValue);
    this.choiceClick(selectedValue, this.selectedText);
    this.setData();
    this.selectedData = this.answers != null ? this.questions.Answers[0].ChoiceId : 0;
  }

  choice21Click(selectedValue) {
    this.p5xService.setSecondaryResidence(true);
    this.guaranteeService.setResidencePrinciple('false');
    this.setCharacteristicsQuestionsSelectedList(selectedValue);
    this.selectedText = this.translate.instant(selectedValue);
    this.choiceClick(selectedValue, this.selectedText);
    this.setData();
    this.selectedData = this.answers != null ? this.questions.Answers[0].ChoiceId : 0;
  }

  choiceClick(choice, selectedText) {
    this.resetAnswers();
    this.guaranteeService.setInitialPricingData(null);
    this.characteristicService.setCharacteristicProgressBarDetails();
    if(this.globals.isMobile)
    {this.characteristicService.setmobileCharacteristicProgressBarDetails();}
    this.flag = false;
    const jsonData = sessionStorage.getItem('jsonData');
    const data1 = JSON.parse(jsonData);

    const response = { questionGroups: this.questionGroups, question: null, groupOrder: null };
    // sessionStorage.setItem('data', JSON.stringify(response));
    const today = new Date();

    for (const ch of this.choices) {
      if (ch.ChoiceKey === choice) {
        this.nextQuestionId = ch.NextQuestionId;
        const AnswerObject = {
          ChoiceId: ch.ChoiceId, Answerkey: ch.ChoiceKey, AnswerText: selectedText,
          AnsweredDateTime: formatDate(today, 'dd-MM-yyyy hh:mm:ss', 'en-US', '+0530')
        };
        data1.Sections[0].QuestionGroup.find(obj => obj.GroupKey === 'G5').Questions[0].Answers = [AnswerObject];

        if (ch.HasInfoPopup) {
          this.notification.openDialog(ch.InfoPopupKey);
        }
      }
    }
    sessionStorage.setItem('jsonData', JSON.stringify(data1));
  }

  helpDialog(value: string) {
    this.selectedText = this.translate.instant(value);
    this.notification.openDialog(this.selectedText);
  }
  //#endregion
}
